// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"1999f1be","152":"7b05ab7d","169":"057165e0","488":"80d76be0","505":"048e5deb","517":"66a27d9c","928":"cadc0056"}[chunkId] + ".chunk.js";
};